import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useEmbed } from '@/contexts/EmbedContext';
import { embedPath } from '@/utils/accountRoutes';

/**
 * O que a casca entrega à vitrine, num lugar só: quem pode decidir a contratação e a porta "Falar com a Touchworks" (hoje, o
 * Suporte). A vitrine não importa de planos, rotas nem autenticação: quem a monta usa isto (o portão de módulo e a ponte da
 * Inbox). `canContract` vale para administrador e superadmin (docs/specs/otto/VITRINE.md §5).
 * @returns {{ canContract: boolean, talkToSales: () => void }}
 */
export function useShowcaseShell() {
    const { isAdmin, isSuperAdmin } = useAuth();
    const { isEmbed } = useEmbed();
    const navigate = useNavigate();
    const talkToSales = useCallback(() => navigate(isEmbed ? embedPath('/support') : '/internal/support'), [navigate, isEmbed]);
    return { canContract: isSuperAdmin() || isAdmin(), talkToSales };
}

export default useShowcaseShell;
